import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.OverviewPage.components.DisableUsageReminder.title',
    defaultMessage: 'Disable usage reminder email',
  },
  enabled: {
    id: 'containers.OrderPage.components.OverviewPage.components.DisableUsageReminder.enabled',
    defaultMessage: 'Usage reminder email enabled',
  },
  disabled: {
    id: 'containers.OrderPage.components.OverviewPage.components.DisableUsageReminder.disabled',
    defaultMessage: 'Usage reminder email disabled',
  },
})
